var _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigiforumMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "url(#paint0_linear_236_8778)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2491 34.8603C39.261 37.2921 37.662 39.422 35.6179 41.0292C33.5737 42.6365 31.1587 43.6627 28.623 44.0016C26.0872 44.3406 23.5229 43.9798 21.1957 42.9568C18.8685 41.9338 16.8631 40.2858 15.387 38.1833L18.4898 35.8622C19.5734 37.4056 21.0457 38.6155 22.7541 39.3666C24.4626 40.1176 26.3451 40.3824 28.2067 40.1336C30.0683 39.8848 31.8412 39.1314 33.3419 37.9514C34.8426 36.7715 36.0164 35.2079 36.7418 33.4227L40.2491 34.8603Z",
    fill: "url(#paint1_linear_236_8778)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5698 33.4958C38.5817 35.9276 36.9828 38.0574 34.9386 39.6647C32.8945 41.272 30.4795 42.2982 27.9437 42.6371C25.4079 42.976 22.8437 42.6153 20.5165 41.5923C18.1893 40.5693 16.1838 38.9212 14.7078 36.8188L17.8105 34.4976C18.8941 36.0411 20.3664 37.251 22.0749 38.002C23.7834 38.753 25.6659 39.0179 27.5275 38.769C29.389 38.5202 31.162 37.7668 32.6627 36.5869C34.1633 35.407 35.3372 33.8434 36.0626 32.0581L39.5698 33.4958Z",
    fill: "url(#paint2_linear_236_8778)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1061 19.6958C9.01054 19.555 8.22173 18.5464 8.51493 17.4816C9.02841 15.6169 9.92337 13.8657 11.1551 12.3328C12.8103 10.2729 15.0135 8.68217 17.5364 7.72531C20.0594 6.76845 22.8103 6.48029 25.5044 6.89066C27.5157 7.19703 29.4406 7.88442 31.1698 8.90569C32.1324 9.4742 32.2598 10.768 31.5388 11.621V11.621C30.8545 12.4306 29.6581 12.5356 28.7264 12.028C27.5483 11.3862 26.2572 10.95 24.9136 10.7453C22.9359 10.444 20.9163 10.6556 19.0641 11.3581C17.212 12.0605 15.5945 13.2283 14.3794 14.7406C13.588 15.7254 12.986 16.833 12.5954 18.0118C12.248 19.06 11.2649 19.8447 10.1693 19.7039L10.1061 19.6958Z",
    fill: "#A79EDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7351 33.3726C12.9767 36.9205 16.4905 39.4671 20.5494 40.4854C24.6083 41.5036 28.9016 40.9157 32.5409 38.8431C36.1802 36.7706 38.8869 33.3721 40.101 29.351C41.3151 25.3298 40.9436 20.9937 39.0634 17.24C37.1832 13.4863 33.9382 10.6022 29.9999 9.18464C26.0616 7.76705 21.7314 7.92442 17.9054 9.62419C14.0793 11.324 11.0504 14.436 9.44517 18.3164C7.83998 22.1968 7.78146 26.5485 9.28172 30.471L12.6466 29.1727C11.478 26.1175 11.5236 22.728 12.7739 19.7056C14.0242 16.6831 16.3834 14.2592 19.3635 12.9352C22.3435 11.6113 25.7163 11.4887 28.7838 12.5929C31.8513 13.697 34.3789 15.9434 35.8433 18.8672C37.3078 21.7909 37.5972 25.1682 36.6515 28.3003C35.7059 31.4324 33.5976 34.0794 30.763 35.6937C27.9283 37.308 24.5843 37.7659 21.4229 36.9728C18.2615 36.1797 15.5246 34.1962 13.7786 31.4327L10.7351 33.3726Z",
    fill: "url(#paint3_linear_236_8778)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_236_8778)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6094,
    cy: 24.6765,
    rx: 14.2648,
    ry: 14.3276,
    fill: "url(#paint4_linear_236_8778)",
    shapeRendering: "crispEdges"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9574 28.1591C20.321 28.1591 19.7592 27.9984 19.272 27.6769C18.7848 27.3521 18.4036 26.8947 18.1286 26.3047C17.8535 25.7114 17.7159 25.0104 17.7159 24.2017C17.7159 23.3996 17.8535 22.7036 18.1286 22.1137C18.4036 21.5237 18.7865 21.068 19.277 20.7465C19.7675 20.425 20.3343 20.2642 20.9773 20.2642C21.4744 20.2642 21.8672 20.3471 22.1555 20.5128C22.4472 20.6752 22.6693 20.8608 22.8217 21.0696C22.9775 21.2751 23.0985 21.4441 23.1847 21.5767H23.2841V17.8182H24.4574V28H23.3239V26.8267H23.1847C23.0985 26.9659 22.9759 27.1416 22.8168 27.3537C22.6577 27.5625 22.4306 27.7498 22.1357 27.9155C21.8407 28.0779 21.4479 28.1591 20.9574 28.1591ZM21.1165 27.1051C21.5871 27.1051 21.9848 26.9825 22.3097 26.7372C22.6345 26.4887 22.8814 26.1456 23.0504 25.7081C23.2195 25.2673 23.304 24.7585 23.304 24.1818C23.304 23.6118 23.2211 23.1129 23.0554 22.6854C22.8897 22.2545 22.6444 21.9198 22.3196 21.6811C21.9948 21.4392 21.5938 21.3182 21.1165 21.3182C20.6193 21.3182 20.205 21.4458 19.8736 21.701C19.5455 21.9529 19.2985 22.2959 19.1328 22.7301C18.9704 23.161 18.8892 23.6449 18.8892 24.1818C18.8892 24.7254 18.9721 25.2192 19.1378 25.6634C19.3068 26.1042 19.5554 26.4555 19.8835 26.7173C20.215 26.9759 20.6259 27.1051 21.1165 27.1051Z",
    fill: "#ECECEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5895 25.7759C28.4802 25.4411 28.336 25.1412 28.157 24.876C27.9814 24.6076 27.7709 24.3789 27.5256 24.1899C27.2837 24.001 27.0086 23.8568 26.7003 23.7574C26.3921 23.658 26.054 23.6083 25.6861 23.6083C25.0829 23.6083 24.5344 23.764 24.0405 24.0756C23.5467 24.3871 23.1539 24.8462 22.8623 25.4527C22.5706 26.0593 22.4248 26.8033 22.4248 27.685C22.4248 28.5666 22.5723 29.3107 22.8672 29.9172C23.1622 30.5237 23.5616 30.9828 24.0654 31.2943C24.5692 31.6059 25.1359 31.7617 25.7657 31.7617C26.349 31.7617 26.8627 31.6374 27.3069 31.3888C27.7543 31.1369 28.1023 30.7823 28.3509 30.3249C28.6028 29.8642 28.7287 29.3223 28.7287 28.6992L29.1066 28.7787H26.0441V27.685H29.9219V28.7787C29.9219 29.6173 29.743 30.3464 29.385 30.9662C29.0304 31.586 28.5398 32.0666 27.9134 32.408C27.2903 32.746 26.5744 32.9151 25.7657 32.9151C24.8642 32.9151 24.072 32.703 23.3893 32.2787C22.7098 31.8545 22.1795 31.2513 21.7984 30.4691C21.4205 29.6869 21.2316 28.7588 21.2316 27.685C21.2316 26.8796 21.3393 26.1554 21.5547 25.5124C21.7735 24.8661 22.0817 24.3159 22.4795 23.8618C22.8772 23.4077 23.3478 23.0597 23.8914 22.8178C24.435 22.5758 25.0332 22.4549 25.6861 22.4549C26.2231 22.4549 26.7235 22.5361 27.1876 22.6985C27.6549 22.8576 28.0708 23.0846 28.4354 23.3796C28.8033 23.6712 29.1099 24.0209 29.3552 24.4286C29.6004 24.8329 29.7695 25.282 29.8623 25.7759H28.5895Z",
    fill: "#ECECEC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_236_8778",
    x: 6.34467,
    y: 10.3489,
    width: 36.5295,
    height: 36.6552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_8778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_8778",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_236_8778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_236_8778",
    x1: 4.5,
    y1: 4,
    x2: 33.4136,
    y2: 59.3272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#909FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41682,
    stopColor: "#64709B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724732,
    stopColor: "#5F74B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4157A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_236_8778",
    x1: 14.437,
    y1: 41.4488,
    x2: 42.4681,
    y2: 53.4826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#697291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_236_8778",
    x1: 16.6044,
    y1: 38.8423,
    x2: 32.2528,
    y2: 44.4963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B995F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7977F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_236_8778",
    x1: 42.4169,
    y1: 31.3374,
    x2: 15.6781,
    y2: 10.8871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595F73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_236_8778",
    x1: 9.04787,
    y1: 20.4433,
    x2: 42.8026,
    y2: 33.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0846355,
    stopColor: "#4E83D2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16161D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiforumMain);
export default __webpack_public_path__ + "static/media/digiforum-main.aac7ff2671de41b5407df15e709f4d55.svg";
export { ForwardRef as ReactComponent };